import { Injectable } from '@angular/core';
import { config } from 'src/app/shared/config';

@Injectable({
  providedIn: 'root'
})
export class LoggerService {

  logMsg(msg: string) {
    if (config.environment == 'local') {
      console.error(msg);
}else{

}
  }
  logObj(obj: { key: string; }) {
    if (config.environment == 'local') {
      console.error(obj);
}else{

}
  }

  constructor() { }

  log(msg: any) {
    if (config.environment == 'local') {
          console.log(msg);
    }else{

    }
  }
  logError(msg: string) {
    if (config.environment == 'local') {
          console.error(msg);
    }else{

    }
  }

}
